// Import npm modules
import LazyLoad from 'vanilla-lazyload';

// Import vendors
import { documentReady } from './vendors/events';

// Import components
import CookieConsent from '../components/modules/cookieConsent';
import Module from '../components/modules/module';
import Carousel from '../components/elements/carousel';
import Image from '../components/elements/image';
import Header from '../components/modules/header';
import Modal from '../components/elements/modal';
import Tooltip from '../components/elements/tooltip';
import CopyLink from '../components/elements/copyLink';

!window.app && console.error('Application: window.app object required.');
// console.log(window.app);

// HTML document has been load and DOM is ready
documentReady(() => {
  new CookieConsent();

  new Module();
});

// Page is fully loaded, including all css, objects, images
window.onload = () => {
  let lazyLoad = new LazyLoad({
    /* eslint-disable */
    elements_selector: '[data-srcset]',
    threshold: 150,
    class_loaded: 'loaded',
    data_srcset: 'srcset'
    /* eslint-enable no-alert */
  });

  new Carousel(lazyLoad);

  new Image();

  new Header();

  Modal.init();

  new Tooltip({
    targetDistance: -6 // px
  });

  new CopyLink();

  // Test cookie consent's event listener
  /*
  window.addEventListener('app.cookieConsent.onChange', function(event) {
    console.log('Cookie consent has been updated.', app.cookies.cookieConsent.types);
  });
  */
};
